export default {"src":"/_next/static/media/workato.cb917be9.svg","height":31,"width":153,"blurWidth":0,"blurHeight":0};